<fieldset [formGroup]="parts" class="six-digit-code-input-container">
  <input #dig1 formControlName="dig1" (input)="handleInput($event, parts.controls.dig1, dig2)" [id]="firstDigitInputId"
    pattern="[0-9]*" type="number" min="0" max="9" inputtype="numeric" maxlength="1"/>

  <input #dig2 formControlName="dig2" (input)="handleInput($event, parts.controls.dig2, dig3)" (keyup)="handleKeyUp($event, parts.controls.dig2, dig3, dig1)"
    pattern="[0-9]*" type="number" min="0" max="9" inputtype="numeric" maxlength="1"/>

  <input #dig3 formControlName="dig3" (input)="handleInput($event, parts.controls.dig3, dig4)" (keyup)="handleKeyUp($event, parts.controls.dig3, dig4, dig2)"
    pattern="[0-9]*" type="number" min="0" max="9" inputtype="numeric" maxlength="1"/>

  <input #dig4 formControlName="dig4" (input)="handleInput($event, parts.controls.dig4, dig5)" (keyup)="handleKeyUp($event, parts.controls.dig4, dig5, dig3)"
    pattern="[0-9]*" type="number" min="0" max="9" inputtype="numeric" maxlength="1"/>

  <input #dig5 formControlName="dig5" (input)="handleInput($event, parts.controls.dig5, dig6)" (keyup)="handleKeyUp($event, parts.controls.dig5, dig6, dig4)"
    pattern="[0-9]*" type="number" min="0" max="9" inputtype="numeric" maxlength="1"/>

  <input #dig6 formControlName="dig6" (input)="handleInput($event, parts.controls.dig6)" (keyup)="handleKeyUp($event, parts.controls.dig6, null, dig5)"
    pattern="[0-9]*" type="number" min="0" max="9" inputtype="numeric" maxlength="1"/>
</fieldset>
